import { render, staticRenderFns } from "./DepartementList.vue?vue&type=template&id=6e11ba22&scoped=true&"
import script from "./DepartementList.vue?vue&type=script&lang=js&"
export * from "./DepartementList.vue?vue&type=script&lang=js&"
import style0 from "./DepartementList.vue?vue&type=style&index=0&id=6e11ba22&lang=scss&scoped=true&"
import style1 from "./DepartementList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e11ba22",
  null
  
)

export default component.exports